import { takeEvery } from 'redux-saga/effects';
import { requestAccessToModuleAction } from '@/domain/env/envActions';
import { requestAccessToModule } from '@/domain/env/sagas';

export default function* changeApplication() {
  yield takeEvery(requestAccessToModuleAction.type, requestAccessToModule);
}
